module.exports = __webpack_public_path__ + "static/media/schedule.8b83a3a1.webp";